import { vrfAbi } from '@/abi'
import { useContractAddresses, useLastSubscriptionId } from '@/hooks'
import { formatEther } from 'viem'
import { useAccount, useReadContracts } from 'wagmi'

export const useSubscriptionConfigs = () => {
  const contracts = useContractAddresses()
  const { address } = useAccount()
  const {
    data: lastSubscriptionId,
    isLoading: isLoadingLastSubscriptionId,
    refetch: refetchLastSubscriptionId,
  } = useLastSubscriptionId()

  const getSubscriptionsInput = []
  const commonInput = {
    abi: vrfAbi,
    address: contracts.vrf,
    functionName: 'getSubscription',
  }

  for (let i = 1; i <= lastSubscriptionId; i++) {
    getSubscriptionsInput.push({ ...commonInput, args: [i] })
  }

  const {
    data: allSubscriptions,
    isLoading,
    refetch: refetchSubscriptions,
  } = useReadContracts({
    contracts: getSubscriptionsInput,
  })

  const mySubscriptions = allSubscriptions?.reduce(
    (filteredSubscriptions, { result = [], status }, subIdAsIndex) => {
      const [balance, reqCount, owner, consumers] = result
      const realSubId = subIdAsIndex + 1

      if (owner === address && status === 'success') {
        filteredSubscriptions.push({
          balance: Number(balance),
          formattedBalance: formatEther(balance || 0),
          reqCount: Number(reqCount),
          owner,
          consumers,
          consumersCount: consumers.length,
          subId: realSubId, // Using the real subscription ID
        })
      }

      return filteredSubscriptions
    },
    [],
  )

  return {
    data: mySubscriptions,
    isLoading: isLoading || isLoadingLastSubscriptionId,
    refetch: () => {
      refetchLastSubscriptionId()
      refetchSubscriptions()
    },
  }
}
